export class GetDeviceRequest {
	public CdrID: number;
	public KaID: number;
	public ShowUsage = true;
	public ShowPing = true;
	public ShowSnapshot = true;
	public ShowStatusChange = true;
	public ShowSite = true;
	public ShowAllocationInfo = true;
	public ShowCluster = true;
	public ShowProductClass = true;
	public ShowActivityStatus = true;
	public ShowScheduler = true;
	public ShowMerchant = true;
	public ShowAggregatedPing = true;
	public ShowRingfenceLogs = true;
	public ShowProxyServers = true;
	public ShowSnapshotLocations = true;
	public ShowUsageCapSettings = true;
	public ShowTLS = true;
	public ShowLatestTLSPingPacket = true;

	constructor(detailsObj: Object) {
		if (detailsObj) {
			this.KaID = detailsObj["KaID"];
			this.CdrID = detailsObj["CdrID"];
		}

		this.ShowUsage = true;
		this.ShowPing = true;
		this.ShowSnapshot = true;
		this.ShowStatusChange = true;
		this.ShowSite = true;
		this.ShowAllocationInfo = true;
		this.ShowCluster = true;
		this.ShowProductClass = true;
		this.ShowActivityStatus = true;
		this.ShowScheduler = true;
		this.ShowMerchant = true;
		this.ShowAggregatedPing = true;
		this.ShowRingfenceLogs = true;
		this.ShowProxyServers = true;
		this.ShowSnapshotLocations = true;
		this.ShowLatestTLSPingPacket = true;
	}
}
